import { makeStyles } from "@material-ui/core/styles";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import RequestsPagePathParams from "../../../api/models/test-request/RequestsPagePathParams";
import TestRequestResponse from "../../../api/models/test-request/TestRequestResponse";
import TestRequestAproeApi from "../../../api/services/TestRequestAproeApi";
import CustomButton from "../../../components/Button/CustomButton";
import { StyledMenu } from "../../../components/Menu/StyledMenu";
import { TestRequestContext } from "../../../contexts/TestRequestContext";
import TestRequestPermissionContext from "../../../contexts/TestRequestPermissionContext";
import useEnv from "../../../hooks/env";
import Dictionary from "../../../models/Dictionary";
import TestRequestActionsMenuItem from "../DescriptionTab/TestRequestActionsMenuItem";
import { AproeAction } from "./models";

const useStyles = makeStyles({
  moreVertIcon: {
    height: "14px",
  },
});

const APROE_ACTIONS_DICTIONARY: Dictionary<AproeAction> = {
  QUALIFICATION: "Set to Qualification",
  DEVELOPMENT: "Set to Development",
  PROTOTYPING: "Set to Prototyping",
  IMPLEMENTATION: "Set to Implementation",
};

const ACTIONS_ORDERED: AproeAction[] = ["QUALIFICATION", "DEVELOPMENT", "PROTOTYPING", "IMPLEMENTATION"];

function excludeCurrentStatus(currentStatus: AproeAction, actionsOrdered: AproeAction[]) {
  return actionsOrdered.filter((a) => a !== currentStatus);
}

interface AproeActionsMenuProps {
  disabled?: boolean;
  preSave: (action: AproeAction) => Promise<void>;
  onSuccess: (data: TestRequestResponse) => void;
}
function AproeActionsMenu({ disabled, preSave, onSuccess: handleSuccess }: AproeActionsMenuProps) {
  const classes = useStyles();
  const { api } = useEnv();
  const { testRequestId } = useParams<RequestsPagePathParams>();
  const testRequestAproeApi = new TestRequestAproeApi(api);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { testRequestObj } = useContext(TestRequestContext);
  const { changeProcessSubStatus } = useContext(TestRequestPermissionContext);
  const availableActions = excludeCurrentStatus(testRequestObj.status.subState, ACTIONS_ORDERED);
  const handleContextMenuClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };
  const handleContextMenuClose = (): void => {
    setAnchorEl(null);
  };
  return (
    <>
      {changeProcessSubStatus && (
        <CustomButton
          onClick={handleContextMenuClick}
          text="Actions"
          startIcon={<MoreVertIcon className={classes.moreVertIcon} />}
        />
      )}
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleContextMenuClose}
      >
        {availableActions.map((action) => (
          <TestRequestActionsMenuItem
            aproe
            type={action}
            close={handleContextMenuClose}
            disabled={!!disabled}
            dictionary={APROE_ACTIONS_DICTIONARY}
            key={action}
            preSave={() => preSave(action)}
            testRequestTitle={testRequestObj.fullTitle}
            onConfirm={() => testRequestAproeApi.changeSubState(testRequestId, action).then(({ data }) => data)}
            onSuccessCallback={handleSuccess}
          />
        ))}
      </StyledMenu>
    </>
  );
}

export default AproeActionsMenu;
